import axios from 'axios';
// import store from '../store';
import moment from 'moment';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'finance';
export default {
    closeeod(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/closing-end-of-day`, obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }
}